import * as idbEdit from "../entity/idb/editInfo";
import * as idbOrder from "../entity/idb/orderInfo";
import * as es6promise from "es6-promise";
import sparkMd5 from "spark-md5";
import { GetEditInfo, util } from "..";
import { Logger } from "../util/logger";

import * as edconst from "./edit.const";


//------------------------------------------------------------------------------
// ユーティリティ
//------------------------------------------------------------------------------

/**
 * 編集画面固有のユーティリティクラス
 * */
export class editUtil {

    /**
     * 組方向(DB値)を文字レイアウトに変換
     * @param direction
     */
    static directionToCharlayout(direction: string): string {

        if (direction === edconst.EditConst.DIRECTION_Y) {
            // 横
            return edconst.EditConst.CHAR_LAYOUT_Y;
        }
        else if (direction === edconst.EditConst.DIRECTION_CY) {
            // センター横
            return edconst.EditConst.CHAR_LAYOUT_CY;
        }
        else {
            // 縦
            return edconst.EditConst.CHAR_LAYOUT_T;
        }
    }


    /**
     * 組方向変換(DB -> 組版)
     * @param direction ：組方向
     */
    static directionToHv(direction: string): edconst.kumihanHv {

        return (direction === edconst.EditConst.DIRECTION_T) ? edconst.KUMIHAN_HV.VERTICAL : edconst.KUMIHAN_HV.HORIZONTAL;

    }



    /**
     * 文字レイアウトを組方向(DB値)に変換
     * @param direction
     */
    static charlayoutToDirection(charlayout: string): string {

        if (charlayout === edconst.EditConst.CHAR_LAYOUT_Y) {
            // 横
            return edconst.EditConst.DIRECTION_Y;
        }
        else if (charlayout === edconst.EditConst.CHAR_LAYOUT_CY) {
            // センター横
            return edconst.EditConst.DIRECTION_CY;
        }
        else {
            // 縦
            return edconst.EditConst.DIRECTION_T;
        }
    }

    /**
     * 行揃え(DB値)をフロント用の行揃え値に変換
     * @param charLayout    ；文字レイアウト
     * @param align         ：行揃え
     */
    static alignToAlignDispVal(charLayout: string, align: string): string {

        let result: string;

        // 行揃え
        if (charLayout === edconst.EditConst.CHAR_LAYOUT_T) {
            // 縦書きの場合
            if (align === "6") {
                result = edconst.EditConst.ALIGN_T_MIDDLE;
            }
            else if (align === "3") {
                result = edconst.EditConst.ALIGN_T_BOTTOM;
            }
            else {
                result = edconst.EditConst.ALIGN_T_TOP;
            }
        }
        else {
            // 横書き or 横書き（中央揃え）の場合
            if (align === "8") {
                result = edconst.EditConst.ALIGN_Y_CENTER;
            }
            else if (align === "9") {
                result = edconst.EditConst.ALIGN_Y_RIGHT;
            }
            else {
                result = edconst.EditConst.ALIGN_Y_LEFT;
            }
        }

        return result;
    }

    /**
     * 揃え位置から9点の変換
     * @param hv    縦/横
     * @param align 行揃え
     */
    static align2Pivot(hv: edconst.kumihanHv, align: string): number {

        let pivot: number = 0;

        if (hv === edconst.KUMIHAN_HV.HORIZONTAL) {
            // 横書きの場合
            if (align === edconst.EditConst.ALIGN_Y_LEFT) {
                pivot = 7;
            }
            else if (align === edconst.EditConst.ALIGN_Y_CENTER) {
                pivot = 8;
            }
            else if (align === edconst.EditConst.ALIGN_Y_RIGHT) {
                pivot = 9;
            }
        }
        else {
            // 縦書きの場合
            if (align === edconst.EditConst.ALIGN_T_BOTTOM) {
                pivot = 3;
            }
            else if (align === edconst.EditConst.ALIGN_T_MIDDLE) {
                pivot = 6;

            }
            else if (align === edconst.EditConst.ALIGN_T_TOP) {
                pivot = 9;
            }
        }

        return pivot;
    }

    /**
     * 9点から揃え位置に変換
     * @param charLayout
     * @param pivot
     */
    static pivot2Align(charLayout: string, pivot: string): string {

        let align: string = "";

        if (charLayout === edconst.EditConst.CHAR_LAYOUT_T) {
            // 縦書きの場合
            if (pivot === "3") {
                align = edconst.EditConst.ALIGN_T_BOTTOM;
            }
            else if (pivot === "6") {
                align = edconst.EditConst.ALIGN_T_MIDDLE;

            }
            else if (pivot === "9") {
                align = edconst.EditConst.ALIGN_T_TOP;
            }
        }
        else {
            // 横書き or 横書き（中央揃え）の場合
            if (pivot === "7") {
                align = edconst.EditConst.ALIGN_Y_LEFT;
            }
            else if (pivot === "8") {
                align = edconst.EditConst.ALIGN_Y_CENTER;
            }
            else if (pivot === "9") {
                align = edconst.EditConst.ALIGN_Y_RIGHT;
            }
        }

        return align;
    }

    /**
     * 行揃え(DB値)をフロント用の行揃え値に変換
     * @param tel    ；文字レイアウト
     */
    static telTypeToTelDispVal(telType: number): string {

        let result: string;

        if (telType === edconst.EditConst.CONTACT_CELLULAR_VAL) {
            result = edconst.EditConst.CONTACT_CELLULAR_DISP;
        }
        else if (telType === edconst.EditConst.CONTACT_FAX_VAL) {
            result = edconst.EditConst.CONTACT_FAX_DISP;
        }
        else if (telType === edconst.EditConst.CONTACT_TEL_FAX_VAL) {
            result = edconst.EditConst.CONTACT_TEL_FAX_DISP;
        }
        else {
            result = edconst.EditConst.CONTACT_TEL_DISP;
        }

        return result;
    }

}


export module editStrage {

    /**
     * WebStorageの初期化
     * @param leavePhoto        ：iDBの画像情報を残すか？(遷移元画面がプレビュー画面？)
     * @param prePagePreview    ：遷移元画面＝プレビュー画面？
     * @param saveAs            ：保存名(編集情報取得の値)
     * @param designNo          ：デザイン番号(不整合チェック用)
     */
    export function initStorage(leavePhoto: boolean, prePagePreview: boolean, browserReload: boolean, saveAs: string, dsnNo: string): idbEdit.editInfo {

        let result: idbEdit.editInfo = null;
        let setEditInfo: idbEdit.editInfo = new idbEdit.editInfo();

        // 保存名設定
        setEditInfo.saveAs = saveAs;

        // デザイン番号の設定
        setEditInfo.dsnNo = dsnNo;

        // editinfo取得
        const readEditInfo: idbEdit.editInfo = util.lstorage.get<idbEdit.editInfo>(util.lstorage.KEY_EDIT, true);
        if (readEditInfo) {
            if (!leavePhoto) {
                // 画像情報のみ引継ぎ
                setEditInfo.photoList = readEditInfo.photoList;
            }
            if (prePagePreview) {
                // あいさつ文情報も引継ぎ
                setEditInfo.greetingInfo = readEditInfo.greetingInfo
                // スタンプ情報も引継ぎ
                setEditInfo.stampInfo = readEditInfo.stampInfo;
                // 印刷タイプも引継ぎ
                setEditInfo.printType = readEditInfo.printType;
                // 枠情報も引継ぎ
                setEditInfo.photoUseList = readEditInfo.photoUseList;
            }
            if (prePagePreview || browserReload) {
                // Myステッカー情報引継ぎ
                setEditInfo.myStampList = readEditInfo.myStampList;
                // 手書きスタンプ情報引継ぎ
                setEditInfo.fontgenicList = readEditInfo.fontgenicList;
            }
        }
        else {
            Logger.debug("editInfo 登録情報なし");
        }
        result = setEditInfo;

        // editinfo更新
        if (util.lstorage.set(util.lstorage.KEY_EDIT, setEditInfo)) {
            // orderinfoは常に削除
            util.lstorage.del(util.lstorage.KEY_ORDER);
        }
        else {
            Logger.error("editInfo 更新失敗");
        }

        return result;
    }

    /**
     * WebStorageへの書き込み
     * @param editInfo   ：起動時の内容
     * @param setEditInfo   ：保存内容
     */
    export function writeStorage(editInfo: GetEditInfo.GetEditInfoResponseEntity, setEditInfo: idbEdit.editInfo): boolean {

        Logger.debug("indexedDBへの書き込み 開始", setEditInfo);

        let result = true;

        // ハガキマスタセット
        const hagakiMasterInfo = {
            hagakiMasterInfo: editInfo.master.hagaki
        }
        if (!util.lstorage.set(util.lstorage.KEY_MASTER, hagakiMasterInfo)) {
            Logger.error("idb 更新失敗 [" + util.lstorage.KEY_MASTER + "]");
            result = false;
        }

        // OrderInfo
        const oi = new idbOrder.orderInfo();
        oi.isTrial = editInfo.isTrial;
        if (editInfo.isTrial) {
            oi.num = 1;
            oi.postcardType = "7"; // 1枚無料ハガキ
        }
        if (!util.lstorage.set(util.lstorage.KEY_ORDER, oi)) {
            Logger.error("idb 更新失敗 [" + util.lstorage.KEY_ORDER + "]");
            result = false;
        }

        Logger.debug("idb editInfo 更新開始", setEditInfo);

        if (result) {
            // 更新
            if (util.lstorage.set(util.lstorage.KEY_EDIT, setEditInfo)) {
                // 更新成功
                result = true;
            }
            else {
                // 更新失敗
                Logger.error("idb editInfo 更新失敗 [" + util.lstorage.KEY_EDIT + "]");
            }
        }

        Logger.debug("idb editInfo 更新完了 result[" + result + "]");

        return result;
    }

    /**
     * WebStorageへの書き込み(画像情報のみ)
     * @param setPhotoList   ：保存内容
     */
    export function writeStorageToPhoto(setPhotoList: idbEdit.photo[]): boolean {

        Logger.debug("WebStorageへの書き込み(画像情報のみ) 開始", setPhotoList);

        // editinfo取得
        let setEditInfo: idbEdit.editInfo = util.lstorage.get<idbEdit.editInfo>(util.lstorage.KEY_EDIT, true);
        if (setEditInfo) {
            setEditInfo.photoList = setPhotoList;
        }
        else {
            setEditInfo = new idbEdit.editInfo();
        }

        // 更新
        if (util.lstorage.set(util.lstorage.KEY_EDIT, setEditInfo)) {
            Logger.debug("WebStorageへの書き込み(画像情報のみ) 終了");
            return true;
        } else {
            Logger.error("WebStorage 更新失敗 [" + util.lstorage.KEY_EDIT + "]");
            return false;
        }
    }

    /**
     * WebStorageへの書き込み(Myステッカー情報のみ)
     * @param setMyStampList   ：保存内容
     */
    export function writeStorageToMyStamp(setMyStampList: idbEdit.photo[]): boolean {

        Logger.debug("WebStorageへの書き込み(Myステッカー情報のみ) 開始", setMyStampList);

        // editinfo取得
        let setEditInfo: idbEdit.editInfo = util.lstorage.get<idbEdit.editInfo>(util.lstorage.KEY_EDIT, true);
        if (setEditInfo) {
            setEditInfo.myStampList = setMyStampList;
        }
        else {
            setEditInfo = new idbEdit.editInfo();
        }

        // 更新
        if (util.lstorage.set(util.lstorage.KEY_EDIT, setEditInfo)) {
            Logger.debug("WebStorageへの書き込み(Myステッカー情報のみ) 終了");
            return true;
        } else {
            Logger.error("WebStorage 更新失敗 [" + util.lstorage.KEY_EDIT + "]");
            return false;
        }
    }

    /**
     * WebStorageへの書き込み(手書きスタンプ情報のみ)
     * @param setTegakiStampList   ：保存内容
     */
    export function writeStorageToTegakiStamp(setTegakiStampList: idbEdit.photo[]): boolean {

        Logger.debug("WebStorageへの書き込み(手書きスタンプ情報のみ) 開始", setTegakiStampList);

        // editinfo取得
        let setEditInfo: idbEdit.editInfo = util.lstorage.get<idbEdit.editInfo>(util.lstorage.KEY_EDIT, true);
        if (setEditInfo) {
            setEditInfo.fontgenicList = setTegakiStampList;
        }
        else {
            setEditInfo = new idbEdit.editInfo();
        }

        // 更新
        if (util.lstorage.set(util.lstorage.KEY_EDIT, setEditInfo)) {
            Logger.debug("WebStorageへの書き込み(手書きスタンプ情報のみ) 終了");
            return true;
        } else {
            Logger.error("WebStorage 更新失敗 [" + util.lstorage.KEY_EDIT + "]");
            return false;
        }
    }


    /**
     * WebStorageからのEditinfoの読込
     */
    export function readStorageForEditInfo(): idbEdit.editInfo {

        let result: idbEdit.editInfo = null;

        // editinfo取得
        result = util.lstorage.get<idbEdit.editInfo>(util.lstorage.KEY_EDIT, true);
        if (result) {
            return result;
        }
        else {
            Logger.error("idb editInfo 取得失敗 [" + util.lstorage.KEY_EDIT + "]");
            return null;
        }

    }

}

/**
 * アップロードファイルをソースにMD5算出
 * @param file
 */
export function calcCheckSum(file: File): es6promise.Promise<string> {

    return new es6promise.Promise((resolve, reject) => {

        const spark = new sparkMd5.ArrayBuffer();
        const reader: FileReader = new FileReader();
        const blobSlice = File.prototype.slice;                 // || File.prototype.mozSlice || File.prototype.webkitSlice
        const chunkSize: number = 2097152;                      // Read in chunks of 2MB
        const chunks: number = Math.ceil(file.size / chunkSize);
        let currentChunk: number = 0;

        reader.onload = function (e) {
            Logger.debug("file[" + file.name + "] read chunk nr", currentChunk + 1, "of", chunks);

            spark.append(e.target.result);                   // Append array buffer
            currentChunk++;

            if (currentChunk < chunks) {
                loadNext();
            } else {
                //Logger.debug("file[" + file.name + "] computed hash trial[", spark.end() + "]");  // Compute hash
                const md5: string = spark.end();
                Logger.debug("file[" + file.name + "] computed hash true[", md5 + "]");  // Compute hash
                resolve(md5);
            }
        };

        reader.onerror = function () {
            Logger.warn('oops, something went wrong.');
            reject();
        };

        function loadNext() {
            const start: number = currentChunk * chunkSize;
            const end: number = ((start + chunkSize) >= file.size) ? file.size : start + chunkSize;

            reader.readAsArrayBuffer(blobSlice.call(file, start, end));
        }

        loadNext();
    });
}

/**
 * 非同期関数をまとめて実行する非同期関数
 * @param promises
 */
export async function asyncWhenApply(promises: any[]) {
    var defer = $.Deferred();

    $.when.apply($, promises).then(function () {

        Logger.debug("asyncWhenApply arguments[" + JSON.stringify(arguments) + "]");

        defer.resolve(arguments);
    }).catch(function () {
        Logger.debug("asyncWhenApply error arguments[" + JSON.stringify(arguments) + "]");

        defer.reject(arguments);
    });

    return defer.promise();
};

